/**
 * All regions ship as curated point clouds. Mapillary's coverage is patchy
 * outside of mapped streets — random bbox sampling almost never hits a panorama
 * (forests, fields, water). City-center anchors with a 50m search radius hit
 * coverage on the first try in 90%+ of cases.
 */
const DACH_POINTS = [
    { lat: 52.5200, lng: 13.4050 }, // Berlin
    { lat: 48.1374, lng: 11.5755 }, // München
    { lat: 53.5511, lng: 9.9937 }, // Hamburg
    { lat: 50.9375, lng: 6.9603 }, // Köln
    { lat: 50.1109, lng: 8.6821 }, // Frankfurt
    { lat: 48.7758, lng: 9.1829 }, // Stuttgart
    { lat: 51.2277, lng: 6.7735 }, // Düsseldorf
    { lat: 51.5136, lng: 7.4653 }, // Dortmund
    { lat: 51.4556, lng: 7.0116 }, // Essen
    { lat: 53.0793, lng: 8.8017 }, // Bremen
    { lat: 51.3397, lng: 12.3731 }, // Leipzig
    { lat: 51.0504, lng: 13.7373 }, // Dresden
    { lat: 49.4521, lng: 11.0767 }, // Nürnberg
    { lat: 52.3759, lng: 9.7320 }, // Hannover
    { lat: 51.4818, lng: 7.2162 }, // Bochum
    { lat: 51.4344, lng: 6.7623 }, // Duisburg
    { lat: 50.7374, lng: 7.0982 }, // Bonn
    { lat: 49.0069, lng: 8.4037 }, // Karlsruhe
    { lat: 49.4875, lng: 8.4660 }, // Mannheim
    { lat: 48.2082, lng: 16.3738 }, // Wien
    { lat: 47.0707, lng: 15.4395 }, // Graz
    { lat: 48.3069, lng: 14.2858 }, // Linz
    { lat: 47.8095, lng: 13.0550 }, // Salzburg
    { lat: 47.2692, lng: 11.4041 }, // Innsbruck
    { lat: 47.3769, lng: 8.5417 }, // Zürich
    { lat: 46.9480, lng: 7.4474 }, // Bern
    { lat: 46.2044, lng: 6.1432 }, // Genève
    { lat: 47.5596, lng: 7.5886 }, // Basel
    { lat: 46.5197, lng: 6.6323 }, // Lausanne
    { lat: 47.4245, lng: 9.3767 }, // St. Gallen
];
const EUROPE_POINTS = [
    ...DACH_POINTS.slice(0, 10),
    { lat: 48.8566, lng: 2.3522 }, // Paris
    { lat: 51.5074, lng: -0.1278 }, // London
    { lat: 41.9028, lng: 12.4964 }, // Roma
    { lat: 40.4168, lng: -3.7038 }, // Madrid
    { lat: 38.7223, lng: -9.1393 }, // Lisboa
    { lat: 52.3676, lng: 4.9041 }, // Amsterdam
    { lat: 50.8503, lng: 4.3517 }, // Brussels
    { lat: 59.3293, lng: 18.0686 }, // Stockholm
    { lat: 60.1699, lng: 24.9384 }, // Helsinki
    { lat: 55.6761, lng: 12.5683 }, // Copenhagen
    { lat: 59.9139, lng: 10.7522 }, // Oslo
    { lat: 53.3498, lng: -6.2603 }, // Dublin
    { lat: 47.4979, lng: 19.0402 }, // Budapest
    { lat: 50.0755, lng: 14.4378 }, // Praha
    { lat: 52.2297, lng: 21.0122 }, // Warszawa
    { lat: 48.1486, lng: 17.1077 }, // Bratislava
    { lat: 44.4268, lng: 26.1025 }, // București
    { lat: 42.6977, lng: 23.3219 }, // Sofia
    { lat: 37.9838, lng: 23.7275 }, // Athina
    { lat: 41.0082, lng: 28.9784 }, // Istanbul
    { lat: 45.4642, lng: 9.1900 }, // Milano
    { lat: 43.7102, lng: 7.2620 }, // Nice
    { lat: 45.7640, lng: 4.8357 }, // Lyon
    { lat: 41.3851, lng: 2.1734 }, // Barcelona
    { lat: 43.2630, lng: -2.9350 }, // Bilbao
    { lat: 50.4501, lng: 30.5234 }, // Kyiv
    { lat: 56.9496, lng: 24.1052 }, // Riga
    { lat: 54.6872, lng: 25.2797 }, // Vilnius
    { lat: 64.1466, lng: -21.9426 }, // Reykjavík
    { lat: 35.8989, lng: 14.5146 }, // Valletta
];
const USA_POINTS = [
    { lat: 40.7128, lng: -74.0060 }, // New York
    { lat: 34.0522, lng: -118.2437 }, // Los Angeles
    { lat: 41.8781, lng: -87.6298 }, // Chicago
    { lat: 29.7604, lng: -95.3698 }, // Houston
    { lat: 33.4484, lng: -112.0740 }, // Phoenix
    { lat: 39.9526, lng: -75.1652 }, // Philadelphia
    { lat: 29.4241, lng: -98.4936 }, // San Antonio
    { lat: 32.7157, lng: -117.1611 }, // San Diego
    { lat: 32.7767, lng: -96.7970 }, // Dallas
    { lat: 30.2672, lng: -97.7431 }, // Austin
    { lat: 37.7749, lng: -122.4194 }, // San Francisco
    { lat: 47.6062, lng: -122.3321 }, // Seattle
    { lat: 39.7392, lng: -104.9903 }, // Denver
    { lat: 38.9072, lng: -77.0369 }, // Washington DC
    { lat: 25.7617, lng: -80.1918 }, // Miami
    { lat: 33.7490, lng: -84.3880 }, // Atlanta
    { lat: 42.3601, lng: -71.0589 }, // Boston
    { lat: 36.1627, lng: -86.7816 }, // Nashville
    { lat: 35.2271, lng: -80.8431 }, // Charlotte
    { lat: 39.7684, lng: -86.1581 }, // Indianapolis
    { lat: 45.5051, lng: -122.6750 }, // Portland
    { lat: 36.1699, lng: -115.1398 }, // Las Vegas
    { lat: 35.4676, lng: -97.5164 }, // Oklahoma City
    { lat: 39.0997, lng: -94.5786 }, // Kansas City
    { lat: 38.6270, lng: -90.1994 }, // St. Louis
    { lat: 42.3314, lng: -83.0458 }, // Detroit
    { lat: 44.9778, lng: -93.2650 }, // Minneapolis
    { lat: 39.2904, lng: -76.6122 }, // Baltimore
    { lat: 40.4406, lng: -79.9959 }, // Pittsburgh
    { lat: 35.0844, lng: -106.6504 }, // Albuquerque
];
const WORLD_POINTS = [
    ...EUROPE_POINTS.slice(10, 30),
    ...USA_POINTS.slice(0, 15),
    { lat: 35.6762, lng: 139.6503 }, // Tokyo
    { lat: 22.3193, lng: 114.1694 }, // Hong Kong
    { lat: 1.3521, lng: 103.8198 }, // Singapore
    { lat: 13.7563, lng: 100.5018 }, // Bangkok
    { lat: 28.6139, lng: 77.2090 }, // Delhi
    { lat: 19.0760, lng: 72.8777 }, // Mumbai
    { lat: 31.2304, lng: 121.4737 }, // Shanghai
    { lat: 37.5665, lng: 126.9780 }, // Seoul
    { lat: -33.8688, lng: 151.2093 }, // Sydney
    { lat: -37.8136, lng: 144.9631 }, // Melbourne
    { lat: -36.8485, lng: 174.7633 }, // Auckland
    { lat: -23.5505, lng: -46.6333 }, // São Paulo
    { lat: -34.6037, lng: -58.3816 }, // Buenos Aires
    { lat: -33.4489, lng: -70.6693 }, // Santiago
    { lat: 4.7110, lng: -74.0721 }, // Bogotá
    { lat: 19.4326, lng: -99.1332 }, // CDMX
    { lat: 25.2048, lng: 55.2708 }, // Dubai
    { lat: 30.0444, lng: 31.2357 }, // Cairo
    { lat: -1.2921, lng: 36.8219 }, // Nairobi
    { lat: -33.9249, lng: 18.4241 }, // Cape Town
    { lat: 6.5244, lng: 3.3792 }, // Lagos
    { lat: 14.5995, lng: 120.9842 }, // Manila
    { lat: -6.2088, lng: 106.8456 }, // Jakarta
    { lat: 21.0285, lng: 105.8542 }, // Hanoi
    { lat: 43.6532, lng: -79.3832 }, // Toronto
    { lat: 49.2827, lng: -123.1207 }, // Vancouver
    { lat: 45.5017, lng: -73.5673 }, // Montreal
    { lat: 55.7558, lng: 37.6173 }, // Moscow
    { lat: 41.0082, lng: 28.9784 }, // Istanbul
    { lat: 24.7136, lng: 46.6753 }, // Riyadh
];
const BSTRD_POINTS = [
    { lat: 52.7325, lng: 8.0561 }, // Vechta-ish, Niedersachsen
    { lat: 52.4583, lng: 9.6919 }, // Burgdorf
    { lat: 52.9079, lng: 11.4581 }, // Salzwedel
    { lat: 53.1342, lng: 9.7156 }, // Soltau Heide
    { lat: 52.3705, lng: 9.7332 }, // Hannover Südstadt Hinterhof
    { lat: 53.2225, lng: 13.2671 }, // Fürstenberg/Havel
    { lat: 52.8512, lng: 13.5234 }, // Templin
    { lat: 53.4109, lng: 13.0653 }, // Neustrelitz
    { lat: 52.5031, lng: 13.4459 }, // Berlin Treptow
    { lat: 52.4769, lng: 13.4318 }, // Neukölln Hinterhof
    { lat: 52.6812, lng: 13.2654 }, // Brandenburg Hennigsdorf
    { lat: 53.0793, lng: 8.8017 }, // Bremen Ostertor
    { lat: 53.5511, lng: 9.9937 }, // Hamburg St. Pauli
    { lat: 53.8654, lng: 11.4298 }, // Wismar
    { lat: 54.0824, lng: 12.1078 }, // Rostock
    { lat: 52.2689, lng: 10.5267 }, // Braunschweig
    { lat: 51.5039, lng: 11.9669 }, // Halle (Saale) Plattenbau
    { lat: 52.1205, lng: 11.6276 }, // Magdeburg
    { lat: 51.7917, lng: 12.2417 }, // Dessau Bauhaus
    { lat: 52.0816, lng: 13.5598 }, // Lübben Spreewald
    { lat: 51.7563, lng: 14.3296 }, // Cottbus
    { lat: 52.6385, lng: 14.5556 }, // Frankfurt (Oder)
    { lat: 53.6393, lng: 11.4057 }, // Schwerin
    { lat: 52.3911, lng: 13.0644 }, // Potsdam
    { lat: 53.2412, lng: 10.4124 }, // Lüneburg
    { lat: 52.1326, lng: 7.6789 }, // Münster
    { lat: 53.4639, lng: 7.4661 }, // Emden
    { lat: 53.3501, lng: 8.5870 }, // Brake/Unterweser
    { lat: 51.4344, lng: 6.7623 }, // Duisburg-Marxloh
    { lat: 51.2562, lng: 7.1508 }, // Wuppertal Schwebebahn
];
export const REGIONS = [
    {
        id: 'world',
        name: 'Welt',
        emoji: '🌍',
        kind: 'points',
        points: WORLD_POINTS,
        scaleKm: 2000,
    },
    {
        id: 'europe',
        name: 'Europa',
        emoji: '🇪🇺',
        kind: 'points',
        points: EUROPE_POINTS,
        scaleKm: 600,
    },
    {
        id: 'dach',
        name: 'DACH',
        emoji: '🥨',
        kind: 'points',
        points: DACH_POINTS,
        scaleKm: 200,
    },
    {
        id: 'usa',
        name: 'USA',
        emoji: '🗽',
        kind: 'points',
        points: USA_POINTS,
        scaleKm: 800,
    },
];
// Kept for backwards-compatibility / curated dorf fallback usage but not in the
// region picker anymore.
void BSTRD_POINTS;
export const REGION_BY_ID = Object.fromEntries(REGIONS.map((r) => [r.id, r]));
export function getRegion(id) {
    if (!id)
        return null;
    return REGION_BY_ID[id] ?? null;
}
